var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');

require('./_styles.scss');
require('../listing-card');
require('../../services/user');
require('../../services/search-results-utils');
require('../../services/search');
require('../third-party/angular-slick');

_module.requires.push(
    'slickCarousel'
);

_module.controller('RelatedListingsCtrl', [
    '$log',
    '$user',
    'srUtils',
    'Search',
    '$element',
    '$scope',

    function RelatedListingsCtrl($log, $user, srUtils, Search, $element, $scope) {
        $log.debug('RelatedListingsCtrl', this);
        $log.debug('RelatedListingsCtrl $element', $element);

        var vm = this;
        vm.model = {
            hide: false,
            listings: [],
            loading: true
        };
        vm.events = {};

        // $watch
        $scope.$watch(function () { return vm.model.hide; }, function onHideChange(value) {
            if(value) {
                $element.css('display', 'none');
            } else {
                $element.css('display', '');
            }
        });

        // Functions
        function getSearchFilterListings(id) {
            $user
                .getSearchFilter(id)
            .then(function (filter) {
                if(filter) {
                    return filter.getListings({ limit: 20 })
                    .then(function (response) {
                        var listings = response.listings
                        .filter(function (listing) {
                            return !~(vm.exclude || []).indexOf(listing.id) && listing.address !== vm.listing.address && listing.match_score > 80;
                        })
                        .map(function (listing) {
                            listing.days_on_market = srUtils.getDaysOnMarket(listing);

                            return listing;
                        });

                        vm.model.listings = _(listings).uniqBy('address').sampleSize(5).orderBy(['match_score'], ['desc']).value();

                        $log.debug('vm.model.listings', vm.model.listings);
                    });
                } else {
                    getRelatedListingsInCity();
                }
            })
            .catch(function onError(err) {
                $log.error('RelatedListingsCtrl -> getSearchFilterListings Error', err);
                getRelatedListingsInCity();
            })
            .finally(function () {
                vm.model.loading = false;
            });
        }

        function getRelatedListingsInCity() {
            var query;

            if(vm.listing.postal_code) {
                query = vm.listing.postal_code;
            } else if(vm.listing.city && vm.listing.state) {
                query = vm.listing.city + ', ' + vm.listing.state;
            } else {
                vm.model.hide = true;
                return;
            }

            var search = new Search(query);

            search.getListings({ limit: 50 })
            .then(function onSearchResponse(response) {
                var listings = response.listings
                .filter(function (listing) {
                    return !~(vm.exclude || []).indexOf(listing.id) && listing.address !== vm.listing.address;
                })
                .map(function (listing) {
                    listing.days_on_market = srUtils.getDaysOnMarket(listing);

                    return listing;
                });

                vm.model.listings = _(listings).uniqBy('address').sampleSize(5).value();

                $log.debug('vm.model.listings', vm.model.listings);
            })
            .catch(function onSearchError(err) {
                $log.error('getRelatedListingsInCity -> $search Error', err);
                vm.model.hide = true;
            })
            .finally(function () {
                vm.model.loading = false;
            });
        }

        function init() {
            if(vm.searchFilterId) {
                getSearchFilterListings(vm.searchFilterId);
            } else {
                getRelatedListingsInCity();
            }
        }

        // init
        init();
    }
]);

_module.component('relatedListings', {
    controller: 'RelatedListingsCtrl',
    controllerAs: 'vm',
    template: require('./index.html'),
    bindings: {
        exclude: '<', // An Array of listing ids to exclude
        listing: '<',
        searchFilterId: '@'
    }
});
